const UserDashboard = () => {

    return (
        <div className="">User</div>
    )
}

export default UserDashboard